<apm-section-title [title]="(('446063' | apmTranslate) ?? '') + ' ' + title()"></apm-section-title>
<div class="statistic-data-list row">
  <div class="col-6 mb-3" *ngFor="let data of statisticDataFiltered()">
    <div
      class="apm-card shadow h-100"
      [ngClass]="{ selected: data.statisticCode === selectedStatisticsCode() }"
      (click)="selectStatistic(data)"
    >
      <fa-icon class="d-block mb-1" *ngIf="data.icon" size="xl" [icon]="data.icon"></fa-icon>
      <div>{{ data.resourceId | apmTranslate }}</div>
    </div>
  </div>
</div>
